//////// GHG 3.11 EA
const threeElevenSchema = {
  title: "3.11 Use of Solid Products",
  addAPI: "cat5_1AddEmissionActivityAPI",
  cat: "cat5_1",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Name / Number",
      resetOnChange: false,
      required: true,
    },
    //////// Activity Type
    {
      key: "activityId",
      level: 1,
      type: "select",
      label: "Activity Type",
      optionsAPI: "cat5_1EADropdownAPI",
      required: true,
    },
  ],
};
export default threeElevenSchema;
